import React from 'react';
import { Grid, Typography, Button, Box } from '@mui/material';
import IconMap from 'assets/icons';

const NoDataAvailable = ({ title, description, isButton, buttonTitle, handelButtonAction }) => {
    return (
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '300px' }}>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',

                        p: 3,
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: '#FAFAFA',
                            width: '30%',
                            height: '140px',
                            borderRadius: '100px',
                            display: 'flex', // Add this to make the Box a flex container
                            alignItems: 'center', // Vertically centers the content
                            justifyContent: 'center' // Horizontally centers the content
                        }}
                    >
                        <IconMap.FolderOpen sx={{ fontSize: 20, color: '#9e9e9e' }} />
                    </Box>
                    <Typography variant="h6" component="h2" gutterBottom>
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                        {description}
                    </Typography>
                    {isButton && (
                        <Button
                            variant="contained"
                            color="warning"
                            onClick={handelButtonAction}
                            sx={{
                                textTransform: 'none',
                                borderRadius: 28,
                                px: 3,
                                py: 1,
                                mt: 2,
                            }}
                        >
                            + {buttonTitle}
                        </Button>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default NoDataAvailable;